import { render, staticRenderFns } from "./cateredProductList.vue?vue&type=template&id=cc1184b6&scoped=true&"
import script from "./cateredProductList.vue?vue&type=script&lang=js&"
export * from "./cateredProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1184b6",
  null
  
)

export default component.exports